webpackJsonp([181503948081111],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Paragraph = function (_Component) {
	  _inherits(Paragraph, _Component);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Paragraph.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        text = _props.text;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        text
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        children
	      )
	    );
	  };
	
	  return Paragraph;
	}(_react.Component);
	
	Paragraph.propTypes = {
	  children: _react.PropTypes.node.isRequired,
	  text: _react.PropTypes.string
	};
	
	exports.default = Paragraph;
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-paypal-3-phones.be69245b.jpg";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-paypal-deck-2.c386fcad.jpg";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-paypal-macbook.116fc3d9.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-paypal-phone.fab05181.jpg";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-paypal-ui-flows.9f220a1f.png";

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-paypal-userflow.0598791e.jpg";

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(24);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _ProjectDetails = __webpack_require__(27);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _ProjectHeader = __webpack_require__(28);
	
	var _ProjectHeader2 = _interopRequireDefault(_ProjectHeader);
	
	var _SingleImage = __webpack_require__(29);
	
	var _SingleImage2 = _interopRequireDefault(_SingleImage);
	
	var _Paragraph = __webpack_require__(190);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	var _p2pPreview_ = __webpack_require__(465);
	
	var _p2pPreview_2 = _interopRequireDefault(_p2pPreview_);
	
	var _p2pFeature = __webpack_require__(464);
	
	var _p2pFeature2 = _interopRequireDefault(_p2pFeature);
	
	var _gumtreePaypalDeck = __webpack_require__(459);
	
	var _gumtreePaypalDeck2 = _interopRequireDefault(_gumtreePaypalDeck);
	
	var _gumtreePaypalUiFlows = __webpack_require__(462);
	
	var _gumtreePaypalUiFlows2 = _interopRequireDefault(_gumtreePaypalUiFlows);
	
	var _gumtreePaypalUserflow = __webpack_require__(463);
	
	var _gumtreePaypalUserflow2 = _interopRequireDefault(_gumtreePaypalUserflow);
	
	var _gumtreePaypalPhone = __webpack_require__(461);
	
	var _gumtreePaypalPhone2 = _interopRequireDefault(_gumtreePaypalPhone);
	
	var _gumtreePaypal3Phones = __webpack_require__(458);
	
	var _gumtreePaypal3Phones2 = _interopRequireDefault(_gumtreePaypal3Phones);
	
	var _gumtreePaypalMacbook = __webpack_require__(460);
	
	var _gumtreePaypalMacbook2 = _interopRequireDefault(_gumtreePaypalMacbook);
	
	__webpack_require__(341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GumtreePayPal = function (_Component) {
	  _inherits(GumtreePayPal, _Component);
	
	  function GumtreePayPal() {
	    _classCallCheck(this, GumtreePayPal);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  GumtreePayPal.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_ProjectHeader2.default, {
	        heading: 'Designing safer and easier ways to buy and sell',
	        client: 'Gumtree Australia'
	      }),
	      _react2.default.createElement(_SingleImage2.default, { img: _p2pPreview_2.default, margin: true }),
	      _react2.default.createElement(
	        _ProjectDetails2.default,
	        {
	          client: 'Gumtree Australia',
	          role: 'User experience designer',
	          duration: '2 months in 2017',
	          deliverables: 'User research, information architecture, wireframes, user flows',
	          agency: 'Pollen',
	          agencylink: 'https://www.pollen.com.au/'
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Background'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Gumtree, Australia\u2019s marketplace, was interested in helping buyers and sellers connect in safer and more trusted ways.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In Australia, PayPal is held in particularly high esteem for both for its safety and convenience. Gumtree asked Pollen to explore the idea of introducing PayPal as a cashless method of payment into the platform.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I worked closely with the PayPal and Gumtree product teams to define a peer-to-peer payments system well suited to the local, face-to-face transactions of Gumtree.'
	        )
	      ),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'User testing'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'To first attain the focus of the opportunity, we worked closely with the PayPal and Gumtree product teams to conduct concept validation sessions with buyers and sellers from the Gumtree platform.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'At this stage, I was responsible for creating a set of user scenarios that demonstrated the ways in which Gumtree users might pay with PayPal. I prepared the script and testing plan for the moderator conducting each session.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I worked alongside Pollen\u2019s senior art director, ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'http://hugovann.com' },
	            'Hugo Vann'
	          ),
	          ', to develop a product vision and develop visuals that would be used during testing to demonstrate each scenario.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePaypalDeck2.default, margin: true, caption: 'I created 8 buyer and seller scenarios for user testing, working with Hugo Vann to develop visuals to match.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Stay local'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'User testing revealed that we needed to stay true to the local marketplace experience of Gumtree. With all existing transactions taking place being face-to-face and cash-in-hand, a mobile, peer-to-peer payments model was a good fit.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'With this in mind, we designed a conversational UI that allowed sellers to accept payment from buyers through Gumtree\u2019s existing messaging system.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePaypalUserflow2.default, margin: true, caption: 'I worked with Adrian Wiggins to create a set of user flows outlining the logic that would underpin the experience.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Working with Adrian Wiggins, I developed an initial round of user flows, before creating high-fidelity wireframes that reflected Gumtree\u2019s existing UI.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'These high-fidelity flows were used to gain legal sign-off, however they also helped demonstrate how the experience would be integrated into the platform\u2019s existing design system to Gumtree\u2019s developers.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePaypalUiFlows2.default, margin: true, caption: 'I created high-fidelity wireframes / flows to demonstrate how the new experience would work within Gumtree\'s existing UI.' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'A new UI'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'With the project occurring concurrently with the new rebrand, the new P2P payments system underwent a new design treatment from Pollen\u2019s Design Lead, ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'http://www.visualicecream.com.au/' },
	            'Brett Walsh'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePaypalPhone2.default, margin: true, stacked: true }),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePaypal3Phones2.default, margin: true, stacked: true }),
	      _react2.default.createElement(_SingleImage2.default, { img: _gumtreePaypalMacbook2.default, margin: true }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Launch'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The Gumtree PayPal integration launched in both Canada and Australia in June 2017. The new system lets Gumtree users pay with PayPal across all platforms and devices - from iPhone to Android devices and the web.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'You can now ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.gumtree.com.au' },
	            'pay with PayPal on the Gumtree website'
	          ),
	          ', ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://play.google.com/store/apps/details?id=com.ebay.gumtree.au&hl=en' },
	            'download the app for free on the App Store'
	          ),
	          ', or ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://www.paypal.com/au/webapps/mpp/gumtree' },
	            'learn more about the Gumtree and PayPal partnership here'
	          ),
	          '.'
	        )
	      )
	    );
	  };
	
	  return GumtreePayPal;
	}(_react.Component);
	
	GumtreePayPal.propTypes = {
	  children: _react.PropTypes.node
	};
	
	exports.default = GumtreePayPal;
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/p2p-feature-2.ac1a8225.jpg";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/p2p-preview_1600.a1900d3b.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-gumtree-paypal-index-js-61c0822ba58b821c5a2a.js